module.exports = __webpack_public_path__ + "static/media/MierA-Book.b58dcc32.ttf";